export default __webpack_public_path__ + "static/media/frame3.18ecdf61.png";